export enum AddToSpaceResources {
    DASHBOARD = 'dashboard',
    CHART = 'chart',
}
